module.exports = __webpack_public_path__ + "img/1_034.d7d12fa1.jpg";